export const ProgressBar = ({ step, total }) => (
  <div className="fixed top-0 left-0 w-full h-1 bg-[#E2EAE4] z-50" data-testid="progress-bar">
    <div
      className="h-full bg-[#4A6B56] transition-all duration-700 ease-out"
      style={{ width: `${(step / total) * 100}%` }}
    />
  </div>
);
